(function () {
  if (window.__hotCartGiftInlineBound) return;
  window.__hotCartGiftInlineBound = true;

  var VASE_HANDLES = {
    '45091094888757': 'beige-textured-vase',
    '45091055272245': 'textured-neck-vase-black'
  };
  var VASE_VARIANT_IDS = Object.keys(VASE_HANDLES);

  var selections = {};
  var renderToken = 0;
  var locked = {};
  var orphanCleanupDone = false;

  var queue = Promise.resolve();
  function enqueue(task) {
    var result = queue.then(task, task);
    queue = result.catch(function () {});
    return result;
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function setLocked(pairKey, isLocked) {
    locked[pairKey] = isLocked;
    document.querySelectorAll('[data-hot-gift-inline][data-pair-key="' + pairKey + '"]').forEach(function (box) {
      box.classList.toggle('is-locked', isLocked);
      box.querySelectorAll('[data-hot-gift-inline-option]').forEach(function (btn) {
        btn.disabled = isLocked || btn.disabled;
      });
    });
  }

  function paint(pairKey, selectedVariant, hiddenMap) {
    document.querySelectorAll('[data-hot-gift-inline][data-pair-key="' + pairKey + '"] [data-hot-gift-inline-option]').forEach(function (btn) {
      var variantId = btn.getAttribute('data-variant-id');
      btn.classList.toggle('is-selected', variantId === selectedVariant);
      if (hiddenMap) {
        var hide = hiddenMap[variantId] === false && variantId !== selectedVariant;
        btn.hidden = hide;
      }
      if (!locked[pairKey]) {
        btn.disabled = hiddenMap ? (hiddenMap[variantId] === false && variantId !== selectedVariant) : false;
      }
    });
  }

  function checkAvailability() {
    var checks = VASE_VARIANT_IDS.map(function (variantId) {
      return fetch('/products/' + VASE_HANDLES[variantId] + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var variant = product.variants.find(function (v) {
            return String(v.id) === variantId;
          });
          return { variantId: variantId, available: !!(variant && variant.available) };
        })
        .catch(function () { return { variantId: variantId, available: true }; });
    });
    return Promise.all(checks);
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function findGiftLinesFor(cart, pairKey) {
    return cart.items.filter(function (item) {
      return item.properties && item.properties._gift_for === pairKey;
    });
  }

  function removeLine(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
  }

  function enforceSingleGiftLine(pairKey, keepVariantId, attemptsLeft) {
    if (attemptsLeft == null) attemptsLeft = 5;
    return getCart().then(function (cart) {
      var lines = findGiftLinesFor(cart, pairKey);
      var extras = lines.filter(function (l) { return String(l.variant_id) !== keepVariantId; });

      if (!extras.length) return;
      if (attemptsLeft <= 0) return;

      var removals = extras.map(function (l) { return removeLine(l.key); });
      return Promise.all(removals)
        .then(function () { return wait(400); })
        .then(function () { return enforceSingleGiftLine(pairKey, keepVariantId, attemptsLeft - 1); });
    });
  }

  // One-time-per-page-load safety net: any gift-tagged vase whose linked
  // Pair line no longer exists in the cart (e.g. that Pair was removed, or
  // is debris left over from an earlier session) gets removed. Without
  // this, an orphaned vase from any past interaction sits in the cart
  // forever, un-discounted, and shows up at checkout as a mystery extra
  // charge that has nothing to do with whatever was just tapped.
  function cleanupOrphanedGifts() {
    if (orphanCleanupDone) return Promise.resolve();
    orphanCleanupDone = true;

    return getCart().then(function (cart) {
      var validKeys = {};
      cart.items.forEach(function (item) {
        validKeys[item.key] = true;
      });

      var orphans = cart.items.filter(function (item) {
        var giftFor = item.properties && item.properties._gift_for;
        return giftFor && !validKeys[giftFor];
      });

      if (!orphans.length) return;
      return Promise.all(orphans.map(function (item) { return removeLine(item.key); }));
    }).catch(function () {});
  }

  function render() {
    var boxes = document.querySelectorAll('[data-hot-gift-inline]');

    enqueue(cleanupOrphanedGifts).then(function () {
      if (!boxes.length) return;
      var myToken = ++renderToken;

      getCart().then(function (cart) {
        if (myToken !== renderToken) return;

        boxes.forEach(function (box) {
          var pairKey = box.getAttribute('data-pair-key');
          if (locked[pairKey]) return;
          var vaseItem = cart.items.find(function (item) {
            return item.properties && item.properties._gift_for === pairKey;
          });
          selections[pairKey] = vaseItem ? String(vaseItem.variant_id) : null;
          paint(pairKey, selections[pairKey], null);
        });

        checkAvailability().then(function (availability) {
          if (myToken !== renderToken) return;
          var hiddenMap = {};
          availability.forEach(function (a) { hiddenMap[a.variantId] = a.available; });
          boxes.forEach(function (box) {
            var pairKey = box.getAttribute('data-pair-key');
            if (locked[pairKey]) return;
            paint(pairKey, selections[pairKey], hiddenMap);
          });
        });
      }).catch(function () {});
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hot-gift-inline-option]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var pairKey = btn.getAttribute('data-pair-key');
    if (locked[pairKey]) return;

    var newVariantId = btn.getAttribute('data-variant-id');
    var previousVariant = selections[pairKey] || null;
    if (newVariantId === previousVariant) return;

    setLocked(pairKey, true);
    selections[pairKey] = newVariantId;
    paint(pairKey, newVariantId, null);

    enqueue(function () {
      return enforceSingleGiftLine(pairKey, null)
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: newVariantId,
              quantity: 1,
              properties: { _gift_for: pairKey }
            })
          });
        })
        .then(function () { return wait(400); })
        .then(function () {
          return enforceSingleGiftLine(pairKey, newVariantId);
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('hot:cart:updated'));
          setLocked(pairKey, false);
          render();
        })
        .catch(function () {
          selections[pairKey] = previousVariant;
          setLocked(pairKey, false);
          render();
        });
    });
  });

  render();
  document.addEventListener('hot:cart:updated', render);
})();
